import { createContext } from "react";
import { DiseaseTrendItem } from "types/diseaseTrendItemType";

export const DiseaseTrendItemContext = createContext(
  {} as {
    diseaseTrendItem: DiseaseTrendItem;
  },
);
